import styled from "styled-components";

export const Main = styled.main`
	flex: 1;
	height: fit-content;
	flex-direction: column;
`
